export enum DateFormatEnum {
  MONTH_DAY_YEAR = 'MM-DD-YYYY',
  YEAR_MONTH_DAY = 'YYYY-MM-DD',
  MONTH_DAY_YAEAR_TIME = 'MM-DD-YYYY HH:mm:ss'
}